export var valuesRouteType = ["SmartMobilityWorld", "Tube", "Podcast"];
/*

*/ 
//# sourceMappingURL=RouteType.js.map